import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Researcher from "@/pages/Researcher";

export const Route = createFileRoute("/researcher")({
  head: () => routeHead('AGAPE Researcher — B2B Research Report', META_DESCRIPTIONS.researcher.en, '/researcher'),
  component: Researcher,
});
